export const classListsTitle = [
  {
    titleName: "id",
    colWidth: "50px",
  },
  { titleName: "Class name", colWidth: "150px", key: "name" },
];
